// show/hide time
const DURATION_MS = 1000;

// arrow & banner container values for show/hide states (position, angle, opacity)
const ARROW_MOVE_START = 50;
const ARROW_MOVE_END = -30;

const ARROW_ROTATE_START = 180;
const ARROW_ROTATE_END = 0;

const ARROW_OPACITY_START = 0.2;
const ARROW_OPACITY_END = 1;

const BANNER_CONTAINER_MOVE_START = 0;
const BANNER_CONTAINER_MOVE_END = -75;

const BANNER_CONTAINER_OPACITY_START = 1;
const BANNER_CONTAINER_OPACITY_END = 0.2;

const CERTIFIED_SHOP_MARK_FLAG = 'certifiedShopHide';
const CERTIFIED_SHOP_MARK_FLAG_HIDE = 'YES';
const CERTIFIED_SHOP_MARK_FLAG_SHOW = 'NO';
// -----------------------------------------------------

$(window).on("load", function() {

    let $bannerContainer = $('.cnj-trust-mark-vertical.cnj-d-flex').first();
    if ($bannerContainer.length == 0) return;

    // get current state (current state stores in localStorage)
    const isHide = fetchBannerDisplayFlag();

    // settings for current state
    const defaultArrowPosition = (isHide ==  CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_MOVE_START : ARROW_MOVE_END;
    const defaultArrowRotate = (isHide == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_ROTATE_START : ARROW_ROTATE_END;
    const defaultArrowOpacity = (isHide == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_OPACITY_START : ARROW_OPACITY_END;
    const defaultBannerContainerPosition = (isHide == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? BANNER_CONTAINER_MOVE_START : BANNER_CONTAINER_MOVE_END;
    const defaultBannerContainerOpacity = (isHide == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? BANNER_CONTAINER_OPACITY_START : BANNER_CONTAINER_OPACITY_END;

    // create arrow button and append it to $bannerContainer
    let arrowBtnSettings = {
        'class': 'mdi mdi-menu-left',
        'data-name': 'mdi-menu-left',
        'css': {
            'color': '#006ed900',
            'font-size': '80px',
            'position': 'fixed',
            'overflow': 'hidden',
            'cursor': 'pointer',
            'float': 'right',
            'top': '40%',
            'z-index': 2000000,
            'right': defaultArrowPosition,
            'transform': 'rotate(' + defaultArrowRotate + 'deg)',
            'opacity': defaultArrowOpacity
        }
    };

    let $arrowBtn = $('<i>', arrowBtnSettings);
    $bannerContainer.before($arrowBtn);
    // -----------------------------------------------------

    // default value for banner Container (for right used no JQuery wrapper, because necessary override !important property)
    $bannerContainer.get(0).style.setProperty('right', defaultBannerContainerPosition + 'px', 'important');
    $bannerContainer.css({opacity: defaultBannerContainerOpacity});
    // -----------------------------------------------------

    // action arrow onClick
    const arrowClickHandler = function() {

        let flag = fetchBannerDisplayFlag();
        const settings = getSettings(flag);

        $({value: 0}).animate({value: 1}, {
            duration: DURATION_MS,
            queue: false,
            step:
                function(currentValue) {
                    // arrow animate: 1. moving & 2. rotate & 3. opacity
                    // 1. arrow moving
                    $arrowBtn.css({right: getAnimateValue(settings.arrowMoveStart, settings.arrowMoveEnd, currentValue) + 'px'});
                    // 2. arrow rotate
                    $arrowBtn.css({transform: 'rotate(' + getAnimateValue(settings.arrowRotateStart, settings.arrowRotateEnd, currentValue) + 'deg)'});
                    // 3. arrow opacity
                    $arrowBtn.css({opacity: getAnimateValue(settings.arrowOpacityStart, settings.arrowOpacityEnd, currentValue)});
                    // bannerContainer animate: 1.moving & 2. opacity
                    // 1. bannerContainer moving
                    $bannerContainer.get(0).style.setProperty('right', getAnimateValue(settings.bannerContainerMoveStart, settings.bannerContainerMoveEnd, currentValue)  + 'px', 'important');
                    // 2. bannerContainer opacity
                    $bannerContainer.css({opacity: getAnimateValue(settings.bannerContainerOpacityStart, settings.bannerContainerOpacityEnd, currentValue)});
                },
            start:
                // disable onClick handler
                function() {
                    $arrowBtn.off("click");
                },
            complete:
                // enable onClick handler, after animation complete
                function() {
                    $arrowBtn.click(arrowClickHandler);
                }
            }
        );

        // update flag state
        const updateFlag = (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? CERTIFIED_SHOP_MARK_FLAG_SHOW : CERTIFIED_SHOP_MARK_FLAG_HIDE;
        localStorage.setItem(CERTIFIED_SHOP_MARK_FLAG, updateFlag);
    };

    $arrowBtn.click(arrowClickHandler);
});

// get moving sign
function getSing(valueStart, valueEnd) {
    if(valueEnd > valueStart) return 1;
    return -1;
}

// get moving distance
function getModule(valueStart, valueEnd) {
    return Math.abs(valueEnd - valueStart);
}

// get step value for animation
function getAnimateValue(valueStart, valueEnd, step) {
    return valueStart + getSing(valueStart, valueEnd) * getModule(valueStart, valueEnd) * step;
};

// get current state
function fetchBannerDisplayFlag() {
    var flag = localStorage.getItem(CERTIFIED_SHOP_MARK_FLAG);
    if(flag == null) {
        localStorage.setItem(CERTIFIED_SHOP_MARK_FLAG, CERTIFIED_SHOP_MARK_FLAG_SHOW);
        flag = CERTIFIED_SHOP_MARK_FLAG_SHOW;
    }
    return flag;
}

// return settings for current state
function getSettings(flag) {
    return {
        arrowMoveStart : (flag == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_MOVE_START : ARROW_MOVE_END,
        arrowMoveEnd : (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? ARROW_MOVE_START : ARROW_MOVE_END,

        arrowRotateStart : (flag == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_ROTATE_START : ARROW_ROTATE_END,
        arrowRotateEnd : (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? ARROW_ROTATE_START: ARROW_ROTATE_END,

        arrowOpacityStart : (flag == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? ARROW_OPACITY_START : ARROW_OPACITY_END,
        arrowOpacityEnd : (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? ARROW_OPACITY_START : ARROW_OPACITY_END,

        bannerContainerMoveStart : (flag == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? BANNER_CONTAINER_MOVE_START : BANNER_CONTAINER_MOVE_END,
        bannerContainerMoveEnd : (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? BANNER_CONTAINER_MOVE_START : BANNER_CONTAINER_MOVE_END,

        bannerContainerOpacityStart : (flag == CERTIFIED_SHOP_MARK_FLAG_SHOW) ? BANNER_CONTAINER_OPACITY_START : BANNER_CONTAINER_OPACITY_END,
        bannerContainerOpacityEnd : (flag == CERTIFIED_SHOP_MARK_FLAG_HIDE) ? BANNER_CONTAINER_OPACITY_START : BANNER_CONTAINER_OPACITY_END
    };
}